import { Controller } from 'stimulus';

// The What's new pill in the top bar (release_notes/_whats_new). Its first
// open marks the releases it lists as seen, the way opening Release Notes
// does, so the pill is gone from the next page. Alpine opens and closes it.
export default class extends Controller {
  seen() {
    if (this.sent) return;
    this.sent = true;
    const meta = document.querySelector('meta[name="csrf-token"]');
    fetch(this.data.get('url'), {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: { 'X-CSRF-Token': meta ? meta.content : '', Accept: 'application/json' }
    }).catch(() => {});
  }
}
